import { StyleSheet, Platform } from 'react-native';
import FontFamily from '../../../constants/fonts';

// Helper function to determine if device is web or tablet
export const isWebOrTabletPlatform = (screenWidth: number): boolean => {
  return Platform.OS === 'web' || screenWidth >= 768;
};

export const createActionPlanFormStyles = StyleSheet.create({
  root: {
    padding: 0,
    alignItems: 'center',
    width: '100%',
  },
  errorBanner: {
    width: '100%',
    backgroundColor: '#FFEBEE',
    borderLeftWidth: 4,
    borderLeftColor: '#D32F2F',
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 16,
    borderRadius: 4,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  errorBannerContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
  },
  errorTextContainer: {
    flex: 1,
    gap: 4,
  },
  errorTitle: {
    fontSize: 14,
    fontWeight: '700',
    color: '#D32F2F',
  },
  errorMessage: {
    fontSize: 13,
    color: '#C62828',
    lineHeight: 18,
  },
  errorCloseButton: {
    padding: 4,
    marginLeft: 8,
  },
  card: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: 24,
    paddingBottom: 24,
    shadowColor: 'rgba(0,94,192,0.08)',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 1,
    shadowRadius: 24,
    elevation: 4,
  },
  header: {
    fontSize: 16,
    fontWeight: '700',
    marginBottom: 16,
    color: '#2D2D2D',
  },
  primaryContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 24,
    marginBottom: 16,
    justifyContent: 'space-between',
  } as any,
  rowWrapView: {
    marginBottom: 24,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 24,
  },
  rowWrapViewMobile: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },
  fieldColumn: {
    flex: 1,
    minWidth: 0,
    marginBottom: 8,
    width: 'auto',
  },
  fieldColumnMobile: {
    flex: 1,
    minWidth: '100%',
    width: '100%',
  },
  fieldColumnSmall: {
    flex: 1,
    minWidth: 0,
    marginBottom: 8,
  },
  fieldColumnSmallMobile: {
    width: '100%',
    paddingRight: 0,
    marginBottom: 12,
  },
  inputWrapper: {
    position: 'relative',
  },
  trailingIcon: {
    position: 'absolute',
    right: 8,
    top: 10,
  },
  selectDisplay: {
    height: 42,
    borderWidth: 1,
    borderColor: '#C0C0C0',
    borderRadius: 4,
    paddingHorizontal: 8,
    backgroundColor: '#FFFFFF',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputText: {
    color: '#2D2D2D',
  },
  placeholderText: {
    color: '#B1B1B1',
  },
  dropdown: {
    position: 'absolute',
    top: 48,
    left: 0,
    right: 0,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#DADADA',
    borderRadius: 4,
    zIndex: 20,
    elevation: 6,
    shadowColor: '#000',
    shadowOpacity: 0.08,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 8,
  },
  dropdownItem: {
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  dropdownItemText: {
    color: '#2D2D2D',
  },
  labelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
    marginTop: 6,
  },
  labelText: {
    fontSize: 12,
    fontFamily: FontFamily.regular,
    fontStyle: 'normal',
    fontWeight: '400',
    color: '#2D2D2D',
  },
  required: {
    color: '#6c757d',
    marginLeft: 6,
    // fontWeight: '700',
    fontSize: 12,
  },
  input: {
    height: 42,
    borderWidth: 1,
    borderColor: '#C0C0C0',
    borderRadius: 4,
    paddingHorizontal: 8,
    backgroundColor: '#FFFFFF',
    color: '#2D2D2D',
  },
  inputDisabled: {
    backgroundColor: '#DADADA',
    color: '#6b6b6b',
    borderWidth: 1,
    borderColor: '#DADADA',
  },
  textareaContainer: {
    marginBottom: 12,
  },
  textarea: {
    minHeight: 120,
    borderWidth: 1,
    borderColor: '#DADADA',
    borderRadius: 4,
    padding: 8,
    backgroundColor: '#FFFFFF',
    color: '#2D2D2D',
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginTop: 4,
    marginBottom: 24,
    width: '100%',
  } as any,
  checkboxTouch: {
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 0,
    width: 24,
    height: 24,
  },
  checkboxLabel: {
    fontSize: 14,
    color: '#4B4B4B',
    flex: 1,
    flexWrap: 'wrap',
    lineHeight: 20,
    marginTop: 0,
    paddingTop: 0,
  },
  checkboxRowMobile: {
    gap: 4,
  },
  employeeSection: {
    width: '100%',
    maxWidth: 420,
    marginTop: 4,
  },
  actionsRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 20,
  } as any,
  actionsRowMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8,
  },
  actionsRowWeb: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  button: {
    height: 32,
    borderRadius: 24,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tertiaryButton: {
      height: 32,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderWidth: 0,
  },
  tertiaryText: {
    color: '#034895',
    fontWeight: '600',
  },
  primaryButton: {
    backgroundColor: '#034895',
  },
  disabledButton: {
    backgroundColor: '#DADADA',
  },
  primaryText: {
    color: '#FFFFFF',
    fontWeight: '700',
  },
  disabledText: {
    color: '#6b6b6b',
  },
  columnWrap: {
    flexDirection: 'column',
    width: '100%',
    marginBottom: 24,
    gap: 32,
  },
  fieldColumnFull: {
    width: '100%',
    paddingRight: 0,
    marginBottom: 0,
  },
  rowWrapMobile: {
    flexDirection: 'row',
    gap: 12,
  },
  readOnlyItem: {
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4,
  },
  viewLabelText: {
    fontSize: 10,
    color: '#4B4B4B',
    fontWeight: '400',
    marginBottom: 2,
  },
  viewContentText: {
    fontSize: 14,
    color: '#000000',
    fontWeight: '500',
  },
  viewContentMultiline: {
    lineHeight: 20,
  },
  errorText: {
    fontSize: 12,
    color: '#DC2626',
    fontWeight: '400',
    marginTop: 4,
  },
  viewAuditTrailButton: {
    borderWidth: 1,
    borderColor: '#005CBC',
    borderRadius: 24,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginTop: 24,
    marginBottom: 24,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FBFCFE',
  },
  viewAuditTrailButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#005CBC',
  },
  areaTooltip: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: [{ translateX: '-50%' }],
    marginBottom: 8,
    backgroundColor: '#1C1C1C',
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 8,
    minWidth: 150,
    zIndex: 1000,
    ...(Platform.OS === 'web' && {
      // @ts-ignore - web-only styles
      transform: 'translateX(-50%)',
    }),
  },
  areaTooltipText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: '400',
    fontFamily: Platform.OS === 'ios' ? 'System' : 'sans-serif',
    textAlign: 'center',
  },
});
